export default __webpack_public_path__ + "static/media/appleLogo.ece66bf6.png";